import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';

const AdminInvite = () => {
    const [searchParams] = useSearchParams();
    const [token, setToken] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const tokenParam = searchParams.get('token');
        if (tokenParam) {
            setToken(tokenParam);
        } else {
            setError('Invalid invite link: missing token');
        }
    }, [searchParams]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            alert("Passwords do not match");
            return;
        }

        setLoading(true);
        try {
            const res = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/admin/invite/complete`, {
                token,
                username,
                password
            });

            alert("Admin account created successfully!");
            // Redirect to login after a short delay
            setTimeout(() => navigate('/login'), 2000);
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.error || 'Failed to complete invite');
        } finally {
            setLoading(false);
        }
    };

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background p-4">
                <div className="bg-card p-8 rounded-xl shadow-lg w-full max-w-md border border-destructive/20 text-center">
                    <h1 className="text-2xl font-bold text-destructive mb-4">Error</h1>
                    <p className="text-muted-foreground">{error}</p>
                    <Button
                        onClick={() => navigate('/login')}
                        className="mt-6"
                    >
                        Go to Login
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4 relative overflow-hidden">
            {/* Premium Header Background */}
            <div className="absolute top-0 left-0 right-0 h-[450px] bg-gradient-to-b from-emerald-50 via-emerald-50/20 to-transparent pointer-events-none z-0" />
            <div className="bg-card p-8 rounded-xl shadow-lg w-full max-w-md border border-border relative z-10">
                <div className="text-center mb-8">
                    <h1 className="text-2xl font-bold text-primary">Team Invitation</h1>
                    <p className="text-muted-foreground text-sm mt-2">Complete your admin account setup</p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-5">
                    <Input
                        label="Choose Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="johndoe"
                        required
                        minLength={3}
                    />

                    <Input
                        type="password"
                        label="Set Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                        minLength={8}
                    />

                    <Input
                        type="password"
                        label="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder="••••••••"
                        required
                    />

                    <Button
                        type="submit"
                        loading={loading}
                        disabled={loading}
                        className="w-full mt-4"
                    >
                        Complete Registration
                    </Button>
                </form>
            </div>
        </div>
    );
};

export default AdminInvite;
